/** API /company index returns `{ data: company }`; session may hold company object directly. */
export function normalizeCompanyRecord(raw) {
  if (!raw || typeof raw !== "object") return null;
  return raw.data !== undefined ? raw.data : raw;
}

export function companyProfileIssues(c) {
  if (c === null || c === undefined) return [];
  const company = normalizeCompanyRecord(c) ?? c;
  if (!company || typeof company !== "object") return [];

  const issues = [];
  if (!String(company.name || "").trim()) issues.push("name");

  const hasLogo = Boolean(company.logo?.id || company.document_logo_id);
  if (!hasLogo) issues.push("logo");

  const contact = [company.email, company.phone, company.mobile].some((v) => String(v || "").trim().length > 0);
  if (!contact) issues.push("contact");

  const addr =
    String(company.physical_address?.address || "").trim() ||
    String(company.delivery_address?.address || company.postal_address?.address || "").trim();
  if (!addr) issues.push("address");

  if (!String(company.sales_conditions_url || "").trim()) issues.push("sales_conditions_url");

  if (!String(company.vat || "").trim()) issues.push("vat");

  return issues;
}

export function hoursSetupIssues({ hourSettings, absenceTypeCount, workScheduleMeta, loadError }) {
  if (loadError) return ["load"];
  if (!hourSettings || typeof hourSettings !== "object") return [];

  const issues = [];

  const hasHoursHandler = Boolean(hourSettings?.hours_handler_id ?? hourSettings?.hours_handler?.id);
  const hasAbsenceHandler = Boolean(
    hourSettings?.absence_handler_id ?? hourSettings?.absence_handler?.id
  );
  if (!hasHoursHandler || !hasAbsenceHandler) issues.push("handlers");

  if (absenceTypeCount !== null && absenceTypeCount === 0) issues.push("absence_types");

  if (workScheduleMeta) {
    const { schedules_count: sc = 0, unassigned_employee_count: un = 0 } = workScheduleMeta;
    if (sc === 0) issues.push("work_schedule_none");
    else if (un > 0) issues.push("work_schedule_unassigned");
  }

  return issues;
}
